import { Card, Heading } from "@/ui";

const SAFETY_INFORMATION = [
  "Cannabis is not recommended during pregnancy or while breastfeeding.",
  "If you have a mental health condition that isn't being treated, like bipolar disorder or schizophrenia, we suggest keeping your THC dose low—ideally no more than 5mg at a time—and only using cannabis under the guidance of a healthcare provider.",
  "If you have any heart conditions, it's also best to limit THC to no more than 5mg per use.",
  "Cannabis can increase drowsiness when taken with medications like opioids, antihistamines, or muscle relaxants, so please use it cautiously.",
  "Use caution with high-dose CBD if you're on anti-epileptic drugs, in cancer treatment, or on blood thinners.",
];

export const SafetyInformationCard = () => {
  return (
    <Card>
      <div className="flex flex-col gap-6 px-6 py-7 md:gap-8 md:px-14 md:py-12">
        <Heading level={2}>Important Safety Information</Heading>
        <ul className="flex list-disc flex-col gap-2 pl-6">
          {SAFETY_INFORMATION.map((item, index) => {
            return <li key={index}>{item}</li>;
          })}
        </ul>
      </div>
    </Card>
  );
};
